import React, { useState, useEffect } from 'react'
import api from '../components/api'


const Modal = (props) => {

    
    const member_id = props.member_id


    const [corporateName, setCorporateName] = useState()
    const [tradeName, setTradeName] = useState()
    const [address, setAddress] = useState()
    const [district, setDistrict] = useState()
    const [city, setCity] = useState()
    const [state, setState] = useState()
    const [responsibleForCompleting, setResponsibleForCompleting] = useState()
    const [positionResponsibleForCompleting, setPositionResponsibleForCompleting] = useState()

    const [climateChallenge, setClimateChallenge] = useState(false)
    const [climateChallengeYears, setClimateChallengeYears] = useState()

    const [wasteChallenge, setWasteChallenge] = useState(false)
    const [wasteChallengeYears, setWasteChallengeYears] = useState()

    const [energyChallenge, setEnergyChallenge] = useState(false)
    const [energyChallengeYears, setEnergyChallengeYears] = useState()

    const [purchaseChallenge, setPurchaseChallenge] = useState(false)
    const [purchaseChallengeYears, setPurchaseChallengeYears] = useState()

    const [scope, setScope] = useState()
    const [nature, setNature] = useState()
    const [type, setType] = useState()
    const [membershipCategory, setMembershipCategory] = useState()
    const [employees, setEmployees] = useState()

    async function carregaDados() {

        await api.get(`memberData/${member_id}`).then((result) => {

            //console.log(result.data)

            var data = result.data[0]

            setCorporateName(data.corporateName)
            setTradeName(data.tradeName)
            setAddress(data.address)
            setDistrict(data.district)
            setCity(data.city)
            setState(data.state)
            setResponsibleForCompleting(data.responsibleForCompleting)
            setPositionResponsibleForCompleting(data.positionResponsibleForCompleting)
            
            setClimateChallenge(data.climateChallenge)
            setClimateChallengeYears(data.climateChallengeYears)

            setWasteChallenge(data.wasteChallenge)
            setWasteChallengeYears(data.wasteChallengeYears)

            setEnergyChallenge(data.energyChallenge)
            setEnergyChallengeYears(data.energyChallengeYears)

            setPurchaseChallenge(data.procurementChallenge)
            setPurchaseChallengeYears(data.procurementChallengeYears)

            setScope(data.scope)
            setNature(data.nature)
            setType(data.nature)
            setMembershipCategory(data.membershipCategory)
            setEmployees(data.employees)


        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {

        if (!isNaN(member_id)) {

            carregaDados()

        }

                
        window.$('[href="#tabM1"]').tab('show');



    }, [member_id])


    return (


        <div>


            <div className="modal fade" id="modalMember" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">Member #{member_id}</h1>
                        </div>
                        <div class="modal-body">


                            <div class="panel-body">

                                <ul className="nav nav-tabs">

                                    <li className="active"><a href="#tabM1" data-toggle="tab">Member's data</a></li>
                                    <li ><a href="#tabM3" data-toggle="tab" >Category</a></li>
                                    <li ><a href="#tabM2" data-toggle="tab" >Challenges</a></li>
                                    
                                    
                                </ul>
                                    
                                <div class="tab-content">
                                    <div class="tab-pane fade in active" id="tabM1">
                                        <div class="panel-body">

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Corporate Name</label>
                                                    <input type="text" className="form-control" value={corporateName} onChange={event => setCorporateName(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Trade Name</label>
                                                    <input type="text" className="form-control" value={tradeName} onChange={event => setTradeName(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Address</label>
                                                    <input type="text" className="form-control" value={address} onChange={event => setAddress(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>District</label>
                                                    <input type="text" className="form-control" value={district} onChange={event => setDistrict(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>City</label>
                                                    <input type="text" className="form-control" value={city} onChange={event => setCity(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>State</label>
                                                    <input type="text" className="form-control" value={state} onChange={event => setState(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Representative Name</label>
                                                    <input type="text" className="form-control" value={responsibleForCompleting} onChange={event => setResponsibleForCompleting(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Representative name's position</label>
                                                    <input type="text" className="form-control" value={positionResponsibleForCompleting} onChange={event => setPositionResponsibleForCompleting(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>
                                        


                                        </div>
                                    </div>
                                    <div className="tab-pane fade in" id="tabM2">
                                        <div class="panel-body">
                                            

                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>Climate</label>
                                                    <select className="form-control" value={climateChallenge} onChange={event => setClimateChallenge(event.target.value)}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <label>Years</label>
                                                    <input type="text" className="form-control" value={climateChallengeYears} onChange={event => setClimateChallengeYears(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>


                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>Waste</label>
                                                    <select className="form-control" value={wasteChallenge} onChange={event => setWasteChallenge(event.target.value)}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <label>Years</label>
                                                    <input type="text" className="form-control" value={wasteChallengeYears} onChange={event => setWasteChallengeYears(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>


                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>Energy</label>
                                                    <select className="form-control" value={energyChallenge} onChange={event => setEnergyChallenge(event.target.value)}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <label>Years</label>
                                                    <input type="text" className="form-control" value={energyChallengeYears} onChange={event => setEnergyChallengeYears(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>


                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>Procurement</label>
                                                    <select className="form-control" value={purchaseChallenge} onChange={event => setPurchaseChallenge(event.target.value)}>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>

                                                                    
                                                </div>
                                            </div>

                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <label>Years</label>
                                                    <input type="text" className="form-control" value={purchaseChallengeYears} onChange={event => setPurchaseChallengeYears(event.target.value)} maxLength={255} />

                                                                    
                                                </div>
                                            </div>


                                        </div>

                                    </div>
                                    <div className="tab-pane fade in" id="tabM3">

                                            <div class="panel-body">
                                                

                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Scope</label>
                                                        <input className="form-control" value={scope} onChange={event => setScope(event.target.value)} />
                                                           

                                                                        
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Nature</label>
                                                        <input className="form-control" value={nature} onChange={event => setNature(event.target.value)} />
                                                           

                                                                        
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Type</label>
                                                        <input className="form-control" value={type} onChange={event => setType(event.target.value)} />
                                                           

                                                                        
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Membership Category</label>
                                                        <input className="form-control" value={membershipCategory} onChange={event => setMembershipCategory(event.target.value)} />
                                                           

                                                                        
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Employees</label>
                                                        <input className="form-control" value={employees} onChange={event => setEmployees(event.target.value)} />
                                                           

                                                                        
                                                    </div>
                                                </div>

                                            </div>

                                    </div>

                                
                                </div>

                            </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-danger" disabled>Apagar</button>
                            <button type="button" className="btn btn-success" disabled>Salvar</button>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>                            
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>


    )

}

export default Modal